export default "__VITE_ASSET__DYsZdDpY__"